export default __webpack_public_path__ + "static/media/BusinessMeeting.b4afcae6.jpeg";